import { coreAdminRoutes } from "./routes/core-routes";
import { executionAdminRoutes } from "./routes/execution-routes";
import { fallbackAdminRoutes } from "./routes/fallback-routes";
import { buildInfrastructureAdminRoutes } from "./routes/infrastructure-routes";
import { knowledgeAdminRoutes } from "./routes/knowledge-routes";

export function buildAirangeAdminRoutes(harborConsoleUrl: string) {
  return [
    ...coreAdminRoutes,
    ...buildInfrastructureAdminRoutes(harborConsoleUrl),
    ...executionAdminRoutes,
    ...knowledgeAdminRoutes,
    ...fallbackAdminRoutes,
  ];
}

export default buildAirangeAdminRoutes("");
